var path = 'components/assignedUsers/assignedUsers.template.html';
var html = "<md-subheader class=\"md-no-sticky md-accent\"> <translate>Assigned User</translate> </md-subheader> <div class=md-padding> <md-input-container class=md-block md-no-float style=width:100%;margin-top:0;margin-bottom:0> <md-select ng-model=vm.selectedUser placeholder=\"{{::'Select User' | translate}}\" ng-disabled=vm.isContentStatusSelected md-on-close=vm.onChange()> <md-option value={{null}}> <em><translate>None</translate></em> </md-option> <md-option ng-repeat=\"user in vm.assignedUsers\" value={{user}}>{{user.UserName}}</md-option> </md-select> </md-input-container> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/assignedUsers/assignedUsers.template.html
// module id = 164
// module chunks = 1